
import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route,  BrowserRouter as Router } from "react-router-dom"
import { Layout, Menu, Breadcrumb, Col, Row } from 'antd';
import { Button,  Progress, Table, Tag, Space } from 'antd';
import { Typography, Switch } from 'antd';
import axios from 'axios'
const { Title } = Typography;
const { Header, Content, Footer } = Layout;


export default class StudentList extends Component{

  state = {
    data:[],
    session: {}
  }
  componentDidMount(nextProps) {
    // if (this.props.state !== nextProps.props.state) {
      let reqData = {
        list_type: this.props.match.params.state
      }
      let data = []
      axios('/record/student_list', {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        // data: reqData
      }).then( res => {
        // let waiting_records = res.data.waiting_records
        // let usernames = res.data.usernames
        // console.log(waiting_records)
        // for (let i=0; i < waiting_records.length; i++) {
        //   let record = waiting_records[i]
        //   let username = usernames[i]

        //   let dict = {
        //     index: i,
        //     primary_class: record.primary_class,
        //     start_at: record.start_at, 
        //     end_at: record.end_at, 
        //     institute: record.institute,
        //     content: record.practice,
        //     tags: record.competency.split(' '),
        //     student: username,
        //     state: record.state,
        //     id: record.id
        //   }
        //   console.log(record)
        //   data.push(dict)
        // }
        // console.log(data)
        this.setState({
          ...this.state,
          prestudents: res.data.prestudents,
          students: res.data.students,
          preprofessors: res.data.preprofessors,
          professors: res.data.professors
        })
      });

    // }
  }

    refresh() {
      axios('/record/student_list', {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        // data: reqData
      }).then( res => {
        this.setState({
          ...this.state,
          prestudents: res.data.prestudents,
          students: res.data.students,
          preprofessors: res.data.preprofessors,
          professors: res.data.professors
        })
      });
    }
    clickToggle(e, id) {
      axios
        .post('/record/accept_user', {
          user_id: id,
          checked: e,
        })
        .then(() => {
          const allUsers = [
            ...(this.state.prestudents || []),
            ...(this.state.students || []),
            ...(this.state.preprofessors || []),
            ...(this.state.professors || []),
          ];
          const target = allUsers.find(u => u.id === id);
          if (target) {
            const isProfType = target.role === 'professor' || target.role === 'preprofessor';
            target.role = e
              ? (isProfType ? 'professor' : 'student')
              : (isProfType ? 'preprofessor' : 'prestudent');
          }
          this.setState({
            ...this.state,
            prestudents: allUsers.filter(u => u.role === 'prestudent'),
            students: allUsers.filter(u => u.role === 'student'),
            preprofessors: allUsers.filter(u => u.role === 'preprofessor'),
            professors: allUsers.filter(u => u.role === 'professor'),
          });
        });
    };

    render(){



      // const data = [
      //   {
      //     key: '1',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '2',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '3',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      //   {
      //     key: '4',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '5',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '6',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      // ];

      const columns = [
        {
          title: '이름',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '학번',
          dataIndex: 'student_number',
          key: 'student_number',
          // render: (index) => <Link to={`/review/${this.state.data[index].id}`} >
          // {
          //   (new Date(this.state.data[index].start_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric', hour:'numeric'})
          // } ~ {
          //   (new Date(this.state.data[index].end_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric', hour:'numeric'})
          // }
          // </Link>,
        },

        {
          title: '이메일',
          dataIndex: 'username',
          key: 'username',
        },

        {
          title: '승인 상태',
          dataIndex:'role',
          key: 'role',
          render: (value, item, index) => 
            <>
              {/* <p>{index}</p> */}
              <Switch
                checkedChildren="승인"
                unCheckedChildren="대기"
                checked={value == 'student'}
                onChange={e => this.clickToggle(e, item.id)}
              />
            </>
          ,
        },
      ];
      // for (let i=0; i < records.length, i++;) {
      //   console.log(i)
      // } 
      // const data = [
      //   {
      //     key: '1',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '2',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '3',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      //   {
      //     key: '4',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '5',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '6',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      // ];


      return (
          // <Row style={{  margin:'50px'}}>
          <>
          <Col  xs={{span:22, offset:1}}  
            sm={{span:20, offset:2}} 
            md={{span:20, offset:2}} 
            lg={{span:20, offset:2}} 
            xxl={{span:16, offset:4}} 

            style={{marginTop:'40px', }}
            // xl={{span:20, offset:2}} 
            // xxl={{span:20, offset:2}} 
           >


              {/* <TestPage hi='' ></TestPage> */}
            <Row span={12}>
              <Col>
                <Title level={3}>미승인 학생목록</Title>
              </Col>
            </Row>
            <Row span={12}>
              <Col span={24}>
                <Table columns={columns} dataSource={this.state.prestudents} />
              </Col>
            </Row>
            <Row span={12}>
              <Col>
                <Title level={3}>기승인 학생목록</Title>
              </Col>
            </Row>
            <Row span={12}>
              <Col span={24}>
                <Table columns={columns} dataSource={this.state.students} />
              </Col>
            </Row>
            <Row span={12}>
              <Col>
                <Title level={3}>미승인 교수목록</Title>
              </Col>
            </Row>
            <Row span={12}>
              <Col span={24}>
                <Table columns={[
                  { title: '이름', dataIndex: 'name', key: 'name' },
                  { title: '이메일', dataIndex: 'username', key: 'username' },
                  { title: '승인 상태', dataIndex: 'role', key: 'role',
                    render: (value, item) => (
                      <Switch
                        checkedChildren="승인"
                        unCheckedChildren="대기"
                        checked={value === 'professor'}
                        onChange={e => this.clickToggle(e, item.id)}
                      />
                    ),
                  },
                ]} dataSource={this.state.preprofessors} />
              </Col>
            </Row>
            <Row span={12}>
              <Col>
                <Title level={3}>기승인 교수목록</Title>
              </Col>
            </Row>
            <Row span={12}>
              <Col span={24}>
                <Table columns={[
                  { title: '이름', dataIndex: 'name', key: 'name' },
                  { title: '이메일', dataIndex: 'username', key: 'username' },
                  { title: '승인 상태', dataIndex: 'role', key: 'role',
                    render: (value, item) => (
                      <Switch
                        checkedChildren="승인"
                        unCheckedChildren="대기"
                        checked={value === 'professor'}
                        onChange={e => this.clickToggle(e, item.id)}
                      />
                    ),
                  },
                ]} dataSource={this.state.professors} />
              </Col>
            </Row>
        </Col>
          </>
        )
    }
}